// extracted by mini-css-extract-plugin
export default {"container":"tag_container__2sBRK","highlight":"tag_highlight__1iYWU","dark":"tag_dark__1VZrE","main":"tag_main__12VBO"};